<script>
import {ElMessage, ElNotification} from "element-plus";
import http from "@/http";

export default {
  name: "SchoolTemplateForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        title: null,
        description: null,
        board_id: null,
        category_id: null,
        requested_amount: 0,
        photo: null
      },
      boards: [],
      categories: [],
      baseUrl: process.env.VUE_APP_BASE_API_URL + 'api/v2/info/file/',
      rules: {
        title: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        requested_amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        description: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        board_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        category_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
      }
    }
  },
  methods: {
    uploadImg(event) {
      this.loading = true;
      const file = event.target.files[0]
      const image = new FormData()
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      this.loading = true
      image.append('file', file)
      http
          .post(url, image, {
            headers: {
              Authorization: this.$store.state.accessToken,
              "Content-Type": "multipart/form-data",
            },
          }).then(({data}) => {
        this.form.photo = data.hashId;
      })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            this.loading = false
          })
    },
    handleImageUpload() {
      const fileInputId = document.getElementById('fileInputRef');
      fileInputId.click()
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/my-school/initiative-templates/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/my-school/initiative-templates", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    },
    getBoards() {
      this.loading = true
      this.$http
          .get(`api/v1/my-school/boards`, {params: {status: 1, offset: 0, limit: 1000}})
          .then(({data}) => {
            this.boards = data.boards;
          })
          .catch((err) => {
            ElNotification.error({
              message:
                  err.response.data.message ||
                  "Doskalar yuklanmadi!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getSchoolCategories() {
      this.loading = true;
      this.$http
          .get(`api/v1/my-school/initiative-categories`, {
            params: {
              limit: 1000,
              offset: 0,
            },
          })
          .then(({data}) => {
            this.categories = data.categories;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getTemplateById() {
      this.loading = true;
      this.$http
          .get(`api/v1/my-school/initiative-templates/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  mounted() {
    this.getBoards();
    this.getSchoolCategories();
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getTemplateById()
    }
  }
}
</script>

<template>
  <div class="accept-initiative">
    <div class="form" v-loading="loading">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-position="top"
              style="width: 100%"
              status-icon
          >
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Nomi" prop="title">
                  <el-input size="large" v-model="form.title" placeholder="Nomini kiriting" clearable
                            style="width: 100%"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="So'ralayotgan qiymati" prop="requested_amount">
                  <el-input-number
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      v-model="form.requested_amount"
                      type="number"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Doskani tanlang" prop="requested_amount">
                  <el-select
                      size="large"
                      v-model="form.board_id"
                      style="width: 100%"
                  >
                    <el-option
                        v-for="board in boards"
                        :key="board.id"
                        :value="board.id"
                        :label="board.title +' ' +board.season +'-' +'mavsum ' +board.year +' yil'"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Toifani tanlang" prop="category_id">
                  <el-select
                      size="large"
                      v-model="form.category_id"
                      style="width: 100%"
                  >
                    <el-option
                        v-for="board in categories"
                        :key="board.id"
                        :value="board.id"
                        :label="board.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10" style="margin-top: 20px">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="Shablon mazmuni" prop="description">
                  <el-input
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      :rows="3"
                      v-model="form.description"
                      type="textarea"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-button id="upload_img" class="info-btn form-input" @click="handleImageUpload">
                  <input type="file" id="fileInputRef" accept="image/jpeg,image/jpg,image/png" @change="uploadImg"
                         style="display: none"/>
                  <img src="@/assets/images/gallery.svg" alt="gallery" style="margin-right: 4px"/>
                  Shablon rasmini yuklang
                </el-button>
              </el-col>
              <div class="images">
                <div class="image-item">
                  <el-image
                      style="margin:15px 0;height: 120px;width: 120px; border:1px solid #e4e4e4; border-radius: 4px;"
                      :src="baseUrl+form.photo"
                      fit="contain"/>
                </div>
              </div>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item>
                  <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                  >Orqaga
                  </el-button
                  >
                  <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash
                  </el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style scoped lang="scss">

.form-fieldset {
  border: 1px solid rgba(137, 141, 141, 0.2);
  border-radius: 5px;
  padding: 5px 8px;

  &:nth-child(3) {
    margin: 20px 0;
  }

  legend {
    font-style: italic;
    font-weight: bold;
  }
}

.images {
  columns: 3;

  .image-item {
    position: relative;

    :deep(el-image) {
      border: 1px solid #e4e4e4;
    }
  }
}
</style>
